import React from "react";
import { Timeline } from "./ui/timeline";

export function ExperienceTimeline() {
  const data = [
    {
      title: "2026",
      content: (
        <div className="pb-4 md:pb-6">
          {/* Wallstreetcn */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Wallstreetcn · Software Engineer Intern
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>June 2026 - Present</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Built financial-content and AI product features across web and mobile using React, React Native, and TypeScript. Developed shared API, state-management, and i18n infrastructure, with Redis caching and Kafka-powered chat streaming.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">React Native</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">TypeScript</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Kafka</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Redis</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "2025",
      content: (
        <div className="pb-4 md:pb-6">
          {/* Brix AI */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Brix AI · Full-Stack Intern
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>June - August 2025</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Built and shipped an AI-powered talent-matching platform with React 19, TypeScript, and Tailwind CSS. Led UI/UX improvements and modular frontend architecture, reducing UI load time by approximately 15%.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">React 19</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">TypeScript</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">AI Product</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">UI/UX</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "2024",
      content: (
        <div className="pb-4 md:pb-6">
          {/* Art AI & Computer Vision Research */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Art AI & Computer Vision Research · Penn State
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>October 2024 - May 2026</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Developed pose-analysis pipelines using DeepPose and SMPLify-X for studying figures in Cassatt and Ukiyo-e artwork. Built an interactive 2D/3D visualization dashboard for exploring pose embeddings and research results.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Computer Vision</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Python</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Data Visualization</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Research</span>
            </div>
          </div>

          {/* Develop for Good */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Develop for Good · UX/UI Designer & Developer Intern
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>May - August 2024</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Designed and developed interactive features for the Free Our Vote platform, increasing user engagement and conversion by over 10%. Improved frontend performance and collaboration between design, frontend, and backend teams.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">UX/UI Design</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">JavaScript</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Frontend</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">AWS</span>
            </div>
          </div>

          {/* ChatWithAI */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              <a
                href="https://www.kgchatnova.top/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4 decoration-[#9F7F63]/60 hover:text-[#9F7F63] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#F1EFE0] transition-colors"
              >
                ChatWithAI Website Project
              </a>
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>September - October 2024</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Built a responsive AI chat application with React and OpenAI APIs, preserving conversation history to generate context-aware responses across multi-turn conversations. Implemented message-state management, reusable chat components, and loading and error-handling flows for a smooth user experience.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">React</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">OpenAI API</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Context Management</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">AI Chat</span>
            </div>
          </div>

          {/* C Multi-user Chatroom */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              C Multi-user Chatroom (GTK)
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>June - July 2024</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Added login, group/private chat, and concurrent connections; 0% message loss in testing.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">C</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">GTK</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Networking</span>
            </div>
          </div>

          {/* PSU CSSA */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              PSU CSSA · Vice President
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>January 2024 - July 2026</p>
            <ul className="list-disc pl-5 space-y-2 text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              <li>Led a 20-member team to plan and execute large-scale cultural and community events.</li>
              <li>Organized the Mid-Autumn Festival Gala, attracting 600+ participants.</li>
              <li>Led sponsorship and commercialization efforts, securing approximately $50,000 in sponsorship funding.</li>
            </ul>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Leadership</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Event Planning</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "2023",
      content: (
        <div className="pb-4 md:pb-6">
          {/* Airbnb */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Airbnb · Software Development Intern
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>May - September 2023</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Built a P2P text-chat system with Java and sockets; designed DB schema and testing/debugging workflows.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Java</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Sockets</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Database</span>
            </div>
          </div>

          {/* NASA L'SPACE */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              NASA L'SPACE Program
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>May - September 2023</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Worked on analysis around Ceres' Occator crater; earned 5 badges (Project Management, Requirements, Risk, Systems, NX Design).
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Space Research</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Project Management</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "2022",
      content: (
        <div className="pb-4 md:pb-6">
          {/* Neural-network Active Learning */}
          <div className="mb-4">
            <h4 className="text-[#F1EFE0] text-lg md:text-xl font-semibold mb-2" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Neural-network Active Learning for ASR
            </h4>
            <p className="text-[#F1EFE0]/80 text-sm mb-3" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>May 2022</p>
            <p className="text-[#F1EFE0]/90 text-sm md:text-base leading-relaxed" style={{fontFamily: 'Cardival-Demo, sans-serif'}}>
              Contributed to research; co-authored paper published at ICMLCA 2021.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Machine Learning</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">Research</span>
              <span className="text-xs px-3 py-1 bg-[#9F7F63]/10 text-[#9F7F63] rounded-full border border-[#9F7F63]/20">ASR</span>
            </div>
          </div>
        </div>
      ),
    },
  ];
  
  return (
    <div className="w-full [font-variant-ligatures:none] [font-feature-settings:'liga'_0,'clig'_0,'calt'_0,'rlig'_0]">
      <Timeline data={data} />
    </div>
  );
}
